<div class="planning_item" (click)="this.selectPlanningItem()">
    <div class="planning_item_header"
        [class.green]="this.planningItem.status.color === 'green'"
        [class.blue]="this.planningItem.status.color === 'blue'"
        [class.orange]="this.planningItem.status.color === 'orange'"
        [class.red]="this.planningItem.status.color === 'red'"
        [class.purple]="this.planningItem.status.color === 'purple'"
        [class.secondary]="this.planningItem.status.color === 'secondary'"
        >
        <div class="planning_item_date">
            @if(this.planningItem.viewDisplayed === 'month'){
                <ion-icon name="calendar-outline"></ion-icon> {{this.planningItem.day | epochToString}}
            }
            <ion-icon name="time-outline"></ion-icon>
            @if(this.planningItem.amStartTime && this.planningItem.pmEndTime){
                {{this.planningItem.amStartTime}} - {{this.planningItem.pmEndTime}}
            }
            @else if(this.planningItem.amStartTime){
                {{this.planningItem.amStartTime}}
            }
            @else if(this.planningItem.pmStartTime){
                {{this.planningItem.pmStartTime}}
            }

            @if(this.planningItem.duration){
                @if(this.planningItem.amStartTime || this.planningItem.pmEndTime){
                    -
                }
                {{this.planningItem.duration}}
            }
        </div>
    </div>
    
    <div class="planning_item_retailer">
        <app-retailer-logo [retailer]="this.planningItem.retailer.logo"/>
        <div class="planning_item_infos">
            @if(this.planningItem.store.name){
                <ion-label class="planning_item_pdv">{{this.planningItem.store.name}}</ion-label>
                <ion-note class="planning_item_pdv_address">
                    {{(this.planningItem.store.administrativeArea ? this.planningItem.store.administrativeArea+' ' : '')}}{{this.planningItem.store.city}}                    
                </ion-note>                
            }
            @else{
                <ion-label class="planning_item_description">{{this.planningItem.description}}</ion-label>
            }
            <div class="planning_item_op">
                <marv-tag [color]="this.missionTypeService.getColor(this.planningItem.operation.typeOfMission)" size="small">{{this.planningItem.operation.name}}</marv-tag>
            </div>     
            
            @if(this.planningItem.planningEntryType === 'STORECHECK' && this.planningItem.purposes){
                <div class="planning_item_purposes">
                    @for(purpose of this.planningItem.purposes; track $index){
                        <div class="planning_item_purpose" [class.fulfilled]="purpose.fulfilled">{{purpose.name}}</div>
                    }
                </div>
            }
            
        </div>
    </div>
    
    <div class="planning_item_profil_content">
        @if(this.planningItem.customerSector?.name){
            <div class="planning_item_sector">
                <ion-icon name="trail-sign-outline"></ion-icon>
                {{this.planningItem.customerSector?.name}}
            </div>
        }

        <div class="planning_item_profil">
            <ion-icon name="person-outline"></ion-icon>
            @if(this.planningItem.salesRep?.name){
                <span class="planning_item_profil_permanent" (click)="this.goToPermanentPlanning($event)"><b>{{this.planningItem.salesRep?.name}}</b></span>
            }
            @else{
                <div>
                    {{'PROFIL' | translate}}
                    @if(this.planningItem.profil){
                        &nbsp;&laquo; {{this.planningItem.profil}} &raquo;
                    }
                    @if(this.planningItem.affected){
                        &nbsp;-&nbsp;<b>{{'AFFECTED' | translate}}</b>
                    }
                </div>
            }

            @if(this.planningItem.recoCompliance){
                <div class="planning_item_reco">{{'RECO' | translate}}</div>
            }        
        </div>
    </div>
    
    @if(this.displayReport && this.planningItem.showPresenceCheckInfos && this.planningItem.planningEntryType === 'STORECHECK'){
        <div class="planning_item_report">   
            @if(this.planningItem.source === 'loga'){ 
                <div>
                    {{'PRESENCE_CONFIRMED' | translate}}
                    @if(this.planningItem.presenceConfirmed){
                        <ion-icon name="thumbs-up-outline" class="green"></ion-icon>
                    }
                    @else{
                        <ion-icon name="thumbs-down-outline" class="orange"></ion-icon>
                    }                
                </div>
            }
            @if(this.planningItem.reportable){
                <div>
                    {{'REPORTING_COMPLETED' | translate}}
                    @if(this.planningItem.reportingCompleted){
                        <ion-icon name="thumbs-up-outline" class="green"></ion-icon>
                    }
                    @else{
                        <ion-icon name="thumbs-down-outline" class="orange"></ion-icon>
                    } 
                </div>        
            }
            
            @if(this.planningItem.source === 'lgg'){ 
                <div class="planning_item_nb_pictures">
                    <div>
                        <ion-icon name="image-outline"></ion-icon>
                        {{this.planningItem.nbPictures}}
                    </div>
                </div>
            }
        </div>
    }
</div>